import { createContext, useContext } from "react";
import { TRAVEL_REWARD_CATALOG, TravelProduct } from "@t3/shared";

interface TravelPackagesContextType {
  packages: TravelProduct[];
}

const TravelPackagesContext = createContext<TravelPackagesContextType>({
  packages: [],
});

export const useTravelPackagesContext = () => {
  return useContext(TravelPackagesContext);
};

export const TravelPackagesProvider = (props: any) => {
  const contextValue: TravelPackagesContextType = {
    packages: TRAVEL_REWARD_CATALOG.brands.sort(
      (a, b) => a.metadata.priority - b.metadata.priority,
    ),
  };

  return <TravelPackagesContext.Provider {...props} value={contextValue} />;
};
